import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";

import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function GlobalValuesForm({ formData, submitForm }) {
  const history = useHistory();
  const { handleSubmit, control, reset, getValues } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });

  useEffect(() => {
    reset(formData);
  }, [formData]);

  //======================================

  return (
    <form onSubmit={handleSubmit(submitForm)} className="w-100" noValidate>
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <form>
              <TextInputFormControl
                label="Variable Name"
                id="columnName"
                placeholder="Variable Name"
                name="columnName"
                value={getValues()?.columnName}
                disabled
              />

              <Controller
                control={control}
                name="columnValue"
                rules={{ required: true, min: 0 }}
                render={({
                  field: { onChange, value, name },
                  fieldState: { error },
                }) => (
                  <NumberInputFormControl
                    label="Variable Value"
                    placeholder="Variable Value"
                    min={0}
                    required
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={error}
                  />
                )}
              />
            </form>
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default GlobalValuesForm;
